import {
  Briefcase,
  Users,
  FileText,
  MoreHorizontal,
  Inbox,
  TrendingUp,
  Clock,
  InProgress,
  Pending,
  Award,
  CalendarClock,
} from '../../../../shared/assets/AppIcons';

export const INITIAL_ASSIGNMENT_FORM = {
  linkType: 'none',
  clientId: '',
  supplierId: '',
  supplierName: '',
  title: '',
  description: '',
  recipientIds: [],
  type: 'altro',
  urgency: 'media',
  dueDate: '',
  attachments: [],
  customFields: {},
};

export const ASSIGNMENT_TYPE_META = {
  gestione_affare: {
    label: 'Gestione Affare',
    badgeClass: 'bg-[var(--chart-accent-1-soft)] text-[var(--chart-accent-1)] border-[var(--border)]',
    icon: Briefcase,
  },
  gestione_cliente: {
    label: 'Gestione Cliente',
    badgeClass: 'bg-[var(--info-soft)] text-[var(--info-text)] border-[var(--border)]',
    icon: Users,
  },
  documentazione: {
    label: 'Documentazione',
    badgeClass: 'bg-[var(--warning-soft)] text-[var(--warning-text)] border-[var(--warning-border)]',
    icon: FileText,
  },
  altro: {
    label: 'Altro',
    badgeClass: 'bg-[var(--surface-raised)] text-[var(--text-primary)] border-[var(--border)]',
    icon: MoreHorizontal,
  },
};

export const ASSIGNMENT_URGENCY_META = {
  alta: { label: 'ALTA', badgeClass: 'bg-[var(--danger-soft)] text-[var(--danger-text)] border-[var(--danger-border)]' },
  media: { label: 'MEDIA', badgeClass: 'bg-[var(--warning-soft)] text-[var(--warning-text)] border-[var(--warning-border)]' },
  bassa: { label: 'BASSA', badgeClass: 'bg-[var(--primary-soft)] text-[var(--primary)] border-[var(--border-strong)]' },
};

export const ASSIGNMENT_STATUS_META = {
  in_corso: {
    label: 'In Corso',
    badgeClass: 'bg-[var(--success-soft)] text-[var(--success-text)] border-[var(--success-border)]',
  },
  da_accettare: {
    label: 'Da Accettare',
    badgeClass: 'bg-[var(--primary-soft)] text-[var(--primary)] border-[var(--border-strong)]',
  },
  completato: {
    label: 'Completato',
    badgeClass: 'bg-[var(--surface-raised)] text-[var(--text-primary)] border-[var(--border)]',
  },
};

export const MY_ASSIGNMENT_TABS = [
  {
    value: 'da_accettare',
    label: 'Da Accettare',
    icon: Pending,
    description: 'Tasks che ti sono stati assegnati e attendono la tua risposta',
  },
  {
    value: 'in_corso',
    label: 'In Corso',
    icon: InProgress,
    description: 'Tasks che ti sono stati assegnati e che hai accettato',
  },
  {
    value: 'completati',
    label: 'Completati',
    icon: Award,
    description: 'Storico dei task completati',
  },
  {
    value: 'mie_richieste',
    label: 'Le mie richieste',
    icon: Inbox,
    description: 'Task creati da te e inviati al team',
  },
];

export const TEAM_ASSIGNMENT_TABS = [
  {
    value: 'da_accettare',
    label: 'Da Accettare',
    icon: Pending,
    description: 'Tasks che attendono risposta dal team',
  },
  {
    value: 'in_corso',
    label: 'In Corso',
    icon: InProgress,
    description: 'Tasks accettati e attivi',
  },
  {
    value: 'completati',
    label: 'Completati',
    icon: Award,
    description: 'Storico dei task completati',
  },
  {
    value: 'scadute',
    label: 'Scadute',
    icon: CalendarClock,
    description: 'Task non completati con data di scadenza trascorsa',
  },
];

export const ASSIGNMENT_TABS = TEAM_ASSIGNMENT_TABS;

export const ASSIGNMENTS_STATS_CONFIG = [
  {
    key: 'overdue',
    title: 'Scadute',
    descriptionKey: 'overdueSummary',
    icon: CalendarClock,
    cardClass: 'border-[var(--border)] bg-gradient-to-br from-[var(--success)] to-[var(--chart-accent-2)]',
    iconWrapClass: 'bg-[var(--success-soft)]',
    iconClass: 'text-[var(--success-text)]',
    titleClass: 'text-[var(--success-text)]',
    valueClass: 'text-[var(--success-text)]',
  },
  {
    key: 'receivedTotal',
    title: 'Tasks Ricevuti',
    descriptionKey: 'receivedSummary',
    icon: Inbox,
    cardClass: 'border-[var(--border)] bg-gradient-to-br from-[var(--primary)] to-[var(--chart-accent-1)]',
    iconWrapClass: 'bg-[var(--primary-soft)]',
    iconClass: 'text-[var(--primary)]',
    titleClass: 'text-[var(--primary)]',
    valueClass: 'text-[var(--primary)]',
  },
  {
    key: 'completionRate',
    title: 'Tasso Completamento',
    descriptionKey: 'completionRateSummary',
    icon: TrendingUp,
    cardClass: 'border-[var(--border)] bg-gradient-to-br from-[var(--warning)] to-[var(--warning)]',
    iconWrapClass: 'bg-[var(--warning-soft)]',
    iconClass: 'text-[var(--warning-text)]',
    titleClass: 'text-[var(--warning-text)]',
    valueClass: 'text-[var(--warning-text)]',
    suffix: '%',
  },
  {
    key: 'myPending',
    title: 'In Attesa',
    descriptionKey: 'pendingSummary',
    icon: Clock,
    cardClass: 'border-[var(--border)] bg-gradient-to-br from-[var(--chart-accent-1)] to-[var(--primary)]',
    iconWrapClass: 'bg-[var(--chart-accent-1-soft)]',
    iconClass: 'text-[var(--chart-accent-1)]',
    titleClass: 'text-[var(--chart-accent-1)]',
    valueClass: 'text-[var(--chart-accent-1)]',
  },
];
